import React from "react";
import PropTypes from "prop-types";

import { UIPhoneField, UITextField } from "../../../../components/ui";

const ClientFormFields = ({
  clients,
  formik,
  emailDisabled,
  inputsValidations,
}) => {
  const getFieldError = (field) => {
    const errorKey = formik.errors[field];
    if (!formik.touched[field] || !errorKey) return "";
    return inputsValidations?.[errorKey] || errorKey;
  };

  return (
  <div className="client-form-field-grid">
    <UITextField
      id="client-name"
      name="name"
      label={clients.addClient.labels.name}
      placeholder={clients.addClient.placeholders.name}
      required
      value={formik.values.name}
      onValueChange={(value) => {
        formik.setFieldTouched("name", true);
        formik.setFieldValue("name", value);
      }}
      error={Boolean(formik.touched.name && formik.errors.name)}
      helperText={getFieldError("name")}
    />
    <UITextField
      id="client-email"
      name="email"
      label={clients.addClient.labels.email}
      placeholder={clients.addClient.placeholders.email}
      required={!emailDisabled}
      disabled={emailDisabled}
      value={formik.values.email}
      onValueChange={(value) => {
        formik.setFieldTouched("email", true);
        formik.setFieldValue("email", value);
      }}
      error={Boolean(formik.touched.email && formik.errors.email)}
      helperText={getFieldError("email")}
    />
    <UIPhoneField
      name="phone"
      label={clients.addClient.labels.mobileNumber}
      placeholder={clients.addClient.placeholders.mobileNumber}
      country="sa"
      preferredCountries={["eg", "sa", "ae"]}
      value={formik.values.phone}
      formValueIsFullInternational
      onChange={(fullValue, countryData) => {
        formik.setFieldTouched("phone", true);
        formik.setFieldValue("phone", fullValue);
        const dc = countryData?.dialCode;
        if (dc != null && dc !== "") {
          formik.setFieldValue(
            "phoneCountryDialCode",
            String(dc).replace(/\D/g, ""),
          );
        }
      }}
      onBlur={() => formik.setFieldTouched("phone", true)}
    />
  </div>
  );
};

ClientFormFields.propTypes = {
  clients: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
  emailDisabled: PropTypes.bool,
  inputsValidations: PropTypes.object.isRequired,
};

ClientFormFields.defaultProps = {
  emailDisabled: false,
};

export default ClientFormFields;
